export const VYAPAR_APP_NAME = 'Loksy Vyapar';
export const CITIZEN_APP_NAME = 'Loksy Citizen';
export const VYAPAR_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.loksy.mitra&hl=en_IN';
export const CITIZEN_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.loksy_citizen&hl=en_IN';

export const DEMO_NAV = [
  { href: "#ecosystem", label: { en: "Ecosystem", te: "ఎకోసిస్టమ్", hi: "इकोसिस्टम" } },
  { href: "#operate", label: { en: "Business Desk", te: "బిజినెస్ డెస్క్", hi: "बिज़नेस डेस्क" } },
  { href: "#connect", label: { en: "Connect", te: "కనెక్ట్", hi: "कनेक्ट" } },
  { href: "#citizen", label: { en: "Citizen", te: "సిటిజన్", hi: "सिटिज़न" } },
  { href: "#outlets", label: { en: "Outlets", te: "అవుట్‌లెట్లు", hi: "आउटलेट" } },
  { href: "#book-demo", label: { en: "Book Demo", te: "డెమో బుక్", hi: "डेमो बुक" } },
];

export const DEMO_COPY = {
  brandEyebrow: {
    en: "Loksy product demo",
    te: "Loksy ప్రోడక్ట్ డెమో",
    hi: "Loksy प्रोडक्ट डेमो",
  },
  heroTitle: {
    en: `${VYAPAR_APP_NAME} + ${CITIZEN_APP_NAME}`,
    te: `${VYAPAR_APP_NAME} + ${CITIZEN_APP_NAME}`,
    hi: `${VYAPAR_APP_NAME} + ${CITIZEN_APP_NAME}`,
  },
  heroHeadline: {
    en: "Run the counter. Grow the town.",
    te: "కౌంటర్ నడపండి. ఊరిని పెంచండి.",
    hi: "काउंटर चलाएँ. शहर बढ़ाएँ.",
  },
  heroBody: {
    en: "One ecosystem for billing, stock, tokens, ads, coupons and local discovery — like a POS that also brings customers from your town.",
    te: "బిల్లింగ్, స్టాక్, టోకెన్, యాడ్స్, కూపన్లు, లోకల్ డిస్కవరీ — అన్నీ ఒకే ఎకోసిస్టమ్‌లో. POSలాగా నడుపుతూ, మీ ఊరి కస్టమర్లను కూడా తీసుకువస్తుంది.",
    hi: "बिलिंग, स्टॉक, टोकन, ऐड्स, कूपन और लोकल डिस्कवरी — एक इकोसिस्टम में. POS की तरह चलाएँ, और अपने शहर के ग्राहक भी पाएँ.",
  },
  ctaDemo: { en: "Book a free demo", te: "ఉచిత డెమో బుక్ చేయండి", hi: "मुफ़्त डेमो बुक करें" },
  ctaVyapar: { en: `Get ${VYAPAR_APP_NAME}`, te: `${VYAPAR_APP_NAME} డౌన్‌లోడ్`, hi: `${VYAPAR_APP_NAME} डाउनलोड` },
  ctaCitizen: { en: `Get ${CITIZEN_APP_NAME}`, te: `${CITIZEN_APP_NAME} డౌన్‌లోడ్`, hi: `${CITIZEN_APP_NAME} डाउनलोड` },
  trustLine: {
    en: "Built for kirana, cafes, salons, clinics, bakeries, QSRs, tuition & local services",
    te: "కిరాణా, కేఫ్, సెలూన్, క్లినిక్, బేకరీ, QSR, ట్యూషన్ & లోకల్ సర్వీసుల కోసం",
    hi: "किराना, कैफ़े, सैलून, क्लिनिक, बेकरी, QSR, ट्यूशन और लोकल सेवाओं के लिए",
  },
  ecosystemTitle: {
    en: "Two apps. One Loksy loop.",
    te: "రెండు యాప్స్. ఒక Loksy లూప్.",
    hi: "दो ऐप्स. एक Loksy लूप.",
  },
  ecosystemBody: {
    en: `${VYAPAR_APP_NAME} runs My Business Desk (Operate) and Connect with Loksy (Grow). ${CITIZEN_APP_NAME} is how townsfolk discover you, order, redeem and return.`,
    te: `${VYAPAR_APP_NAME}లో My Business Desk (Operate) + Connect with Loksy (Grow). ${CITIZEN_APP_NAME}లో పట్టణ ప్రజలు మిమ్మల్ని కనుగొని, ఆర్డర్ చేసి, రిటర్న్ అవుతారు.`,
    hi: `${VYAPAR_APP_NAME} में My Business Desk (Operate) और Connect with Loksy (Grow). ${CITIZEN_APP_NAME} से शहर वाले आपको खोजते, ऑर्डर करते और वापस आते हैं.`,
  },
  operateTitle: {
    en: "My Business Desk — operate like a boss",
    te: "My Business Desk — బాస్‌లా నడపండి",
    hi: "My Business Desk — बॉस की तरह चलाएँ",
  },
  operateBody: {
    en: "Billing, inventory, expenses, enquiries and reports in one phone — without notebook chaos.",
    te: "బిల్లింగ్, ఇన్వెంటరీ, ఖర్చులు, ఎంక్వైరీలు, రిపోర్టులు — నోట్‌బుక్ గందరగోళం లేకుండా ఒకే ఫోన్‌లో.",
    hi: "बिलिंग, इन्वेंटरी, खर्च, पूछताछ और रिपोर्ट — नोटबुक की अफरा-तफरी के बिना एक फ़ोन में.",
  },
  connectTitle: {
    en: "Connect with Loksy — grow beyond the counter",
    te: "Connect with Loksy — కౌంటర్ దాటి ఎదగండి",
    hi: "Connect with Loksy — काउंटर से आगे बढ़ें",
  },
  connectBody: {
    en: "Publish your full shop profile, ads, coupons, tokens and orders so citizens find you every day.",
    te: "పూర్తి షాప్ ప్రొఫైల్, యాడ్స్, కూపన్లు, టోకెన్లు, ఆర్డర్లు పబ్లిష్ చేసి సిటిజన్లకు ప్రతిరోజూ కనిపించండి.",
    hi: "पूरा शॉप प्रोफ़ाइल, ऐड्स, कूपन, टोकन और ऑर्डर पब्लिश करें — सिटिज़न रोज़ आपको देखें.",
  },
  citizenTitle: {
    en: `${CITIZEN_APP_NAME} — your town, one tap away`,
    te: `${CITIZEN_APP_NAME} — మీ ఊరు ఒక్క ట్యాప్‌లో`,
    hi: `${CITIZEN_APP_NAME} — आपका शहर एक टैप में`,
  },
  citizenBody: {
    en: "Directory, radius search, scan-to-order, coupons, updates and jobs — the demand side that feeds your shop.",
    te: "డైరెక్టరీ, రేడియస్ సెర్చ్, స్కాన్-టు-ఆర్డర్, కూపన్లు, అప్‌డేట్స్, జాబ్స్ — మీ షాపుకు కస్టమర్లను తీసుకువచ్చే డిమాండ్ సైడ్.",
    hi: "डायरेक्टरी, रेडियस सर्च, स्कैन-टू-ऑर्डर, कूपन, अपडेट और जॉब्स — मांग की तरफ जो आपकी दुकान तक ग्राहक लाती है.",
  },
  outletsTitle: {
    en: "Built for every local food & service format",
    te: "ప్రతి లోకల్ ఫుడ్ & సర్వీస్ ఫార్మాట్‌కు",
    hi: "हर लोकल फ़ूड और सेवा फ़ॉर्मेट के लिए",
  },
  compareTitle: {
    en: "Notebook shop vs Loksy",
    te: "నోట్‌బుక్ షాప్ vs Loksy",
    hi: "नोटबुक दुकान vs Loksy",
  },
  formTitle: {
    en: "Book a free 10-minute demo",
    te: "10 నిమిషాల ఉచిత డెమో బుక్ చేయండి",
    hi: "10 मिनट का मुफ़्त डेमो बुक करें",
  },
  formBody: {
    en: "See billing, tokens, Connect with Loksy and Citizen discovery live. We save your request under Loksy Leads → Demo Requests.",
    te: "బిల్లింగ్, టోకెన్లు, Connect with Loksy, Citizen డిస్కవరీ లైవ్‌గా చూడండి. మీ రిక్వెస్ట్ Loksy Leads → Demo Requestsలో సేవ్ అవుతుంది.",
    hi: "बिलिंग, टोकन, Connect with Loksy और Citizen डिस्कवरी लाइव देखें. आपका अनुरोध Loksy Leads → Demo Requests में सेव होगा.",
  },
  downloadTitle: {
    en: "Or start on Google Play today",
    te: "లేదా ఇప్పుడే Google Playలో మొదలుపెట్టండి",
    hi: "या आज ही Google Play पर शुरू करें",
  },
  problemLabel: { en: "Problem", te: "సమస్య", hi: "समस्या" },
  solutionLabel: { en: "Loksy way", te: "Loksy పరిష్కారం", hi: "Loksy तरीका" },
  advantageLabel: { en: "Advantage", te: "లాభం", hi: "फ़ायदा" },
  faqTitle: { en: "FAQ", te: "తరచూ అడిగే ప్రశ్నలు", hi: "अक्सर पूछे जाने वाले सवाल" },
};

export const DEMO_FEATURES = [
  {
    id: "billing",
    zone: "operate",
    image: "/images/demo/features/billing-screen.png",
    title: {
      en: "Billing & POS",
      te: "బిల్లింగ్ & POS",
      hi: "बिलिंग और POS",
    },
    problem: {
      en: "Paper bills, wrong totals, no draft recall, tax confusion at peak hours.",
      te: "కాగితం బిల్లులు, తప్పు మొత్తాలు, డ్రాఫ్ట్ లేకపోవడం, పీక్ అవర్స్‌లో టాక్స్ గందరగోళం.",
      hi: "कागज़ी बिल, गलत टोटल, ड्राफ़्ट न मिलना, पीक आवर्स में टैक्स कन्फ़्यूज़न.",
    },
    solution: {
      en: `${VYAPAR_APP_NAME} catalog billing, drafts, taxes, barcode/QR and cash-credit flows on My Business Desk.`,
      te: `${VYAPAR_APP_NAME} My Business Deskలో కేటలాగ్ బిల్లింగ్, డ్రాఫ్ట్‌లు, టాక్స్, బార్‌కోడ్/QR, క్యాష్-క్రెడిట్.`,
      hi: `${VYAPAR_APP_NAME} My Business Desk पर कैटलॉग बिलिंग, ड्राफ़्ट, टैक्स, बारकोड/QR और कैश-क्रेडिट.`,
    },
    advantage: {
      en: "Faster punch bills, fewer errors, printable QR cards for products.",
      te: "వేగంగా బిల్లులు, తక్కువ తప్పులు, ప్రొడక్ట్ QR కార్డులు.",
      hi: "तेज़ बिलिंग, कम गलतियाँ, प्रोडक्ट QR कार्ड.",
    },
  },
  {
    id: "inventory",
    zone: "operate",
    image: "/images/demo/features/stock.webp",
    title: {
      en: "Inventory & catalog",
      te: "ఇన్వెంటరీ & కేటలాగ్",
      hi: "इन्वेंटरी और कैटलॉग",
    },
    problem: {
      en: "Stock only in the owner’s head — oversell, dead stock, messy categories.",
      te: "స్టాక్ ఓనర్ మెదడులోనే — ఓవర్‌సెల్, డెడ్ స్టాక్, అస్తవ్యస్త కేటగిరీలు.",
      hi: "स्टॉक सिर्फ़ मालिक के दिमाग में — ओवरसेल, डेड स्टॉक, बिखरी कैटेगरी.",
    },
    solution: {
      en: "Categories, stock screen, recycle bins and billing catalog synced for daily use.",
      te: "కేటగిరీలు, స్టాక్ స్క్రీన్, రీసైకిల్ బిన్, బిల్లింగ్ కేటలాగ్ — రోజువారీ ఉపయోగానికి సింక్.",
      hi: "कैटेगरी, स्टॉक स्क्रीन, रीसाइकिल बिन और बिलिंग कैटलॉग रोज़ के काम के लिए सिंक.",
    },
    advantage: {
      en: "Know what sells. Stop guessing shelf reality.",
      te: "ఏమి అమ్ముతుందో తెలుసు. షెల్ఫ్‌ను ఊహించకండి.",
      hi: "क्या बिकता है पता रहे. शेल्फ़ का अंदाज़ा न लगाएँ.",
    },
  },
  {
    id: "expenses",
    zone: "operate",
    image: "/images/demo/features/expenses.webp",
    title: {
      en: "Expenditures, purchases & dues",
      te: "ఖర్చులు, పర్చేసులు & బాకీలు",
      hi: "खर्च, खरीदारी और बकाया",
    },
    problem: {
      en: "WhatsApp notes for expenses — no groups, no dues clarity, month-end shock.",
      te: "ఖర్చులు WhatsApp నోట్స్‌లో — గ్రూపులు లేవు, బాకీలు అస్పష్టం, నెలచివర షాక్.",
      hi: "खर्च WhatsApp नोट्स में — कोई ग्रुप नहीं, बकाया अस्पष्ट, महीने के अंत में झटका.",
    },
    solution: {
      en: "Purchases, expense groups, expenses and dues inside Vyapar-style shop accounts.",
      te: "Vyapar-స్టైల్ షాప్ అకౌంట్స్‌లో పర్చేసులు, ఎక్స్‌పెన్స్ గ్రూపులు, ఖర్చులు, బాకీలు.",
      hi: "Vyapar-स्टाइल शॉप अकाउंट्स में खरीदारी, खर्च ग्रुप, खर्च और बकाया.",
    },
    advantage: {
      en: "Cash clarity without needing Tally for a small shop.",
      te: "చిన్న షాపుకు Tally అవసరం లేకుండా నగదు స్పష్టత.",
      hi: "छोटी दुकान के लिए Tally के बिना नकदी की स्पष्टता.",
    },
  },
  {
    id: "enquiry",
    zone: "operate",
    image: "/images/demo/features/customer_leads.webp",
    title: {
      en: "Enquiry forms & Loksy Leads",
      te: "ఎంక్వైరీ ఫారమ్‌లు & Loksy Leads",
      hi: "Enquiry फ़ॉर्म और Loksy Leads",
    },
    problem: {
      en: "Walk-in interest vanishes — no register, no follow-up, missed conversions.",
      te: "వాక్-ఇన్ ఆసక్తి మాయం — రిజిస్టర్ లేదు, ఫాలో-అప్ లేదు, మిస్ అయిన కన్వర్షన్లు.",
      hi: "वॉक-इन रुचि गायब — रजिस्टर नहीं, फ़ॉलो-अप नहीं, छूटे कन्वर्ज़न.",
    },
    solution: {
      en: "Register enquiries and work Loksy Leads with Enquiries and Demo Requests tabs for callbacks.",
      te: "ఎంక్వైరీలు రిజిస్టర్ చేసి Loksy Leadsలో Enquiries మరియు Demo Requests ట్యాబ్‌లతో కాల్‌బ్యాక్ చేయండి.",
      hi: "Enquiry रजिस्टर करें और Loksy Leads में Enquiries और Demo Requests टैब से कॉलबैक करें.",
    },
    advantage: {
      en: "Every lead has an owner action — including website Book Demo requests.",
      te: "ప్రతి లీడ్‌కు యాక్షన్ ఉంటుంది — వెబ్‌సైట్ Book Demo కూడా.",
      hi: "हर लीड पर एक्शन — वेबसाइट Book Demo भी शामिल.",
    },
  },
  {
    id: "reports",
    zone: "operate",
    image: "/images/demo/features/today_sales.webp",
    title: {
      en: "Sales & customer reports",
      te: "సేల్స్ & కస్టమర్ రిపోర్టులు",
      hi: "सेल्स और कस्टमर रिपोर्ट",
    },
    problem: {
      en: "End of day = mental math. No view of who buys or what moved.",
      te: "రోజు చివర = మెంటల్ లెక్క. ఎవరు కొన్నారో, ఏమి అమ్మిందో తెలియదు.",
      hi: "दिन का अंत = दिमागी हिसाब. कौन ख़रीदा, क्या चला — पता नहीं.",
    },
    solution: {
      en: "Today’s sales, sales reports and customer dashboard from Operate.",
      te: "Operate నుంచి ఈరోజు సేల్స్, సేల్స్ రిపోర్టులు, కస్టమర్ డాష్‌బోర్డ్.",
      hi: "Operate से आज की सेल्स, सेल्स रिपोर्ट और कस्टमर डैशबोर्ड.",
    },
    advantage: {
      en: "Decide restock and offers with numbers, not gut feel alone.",
      te: "రీస్టాక్ & ఆఫర్లు సంఖ్యలతో నిర్ణయించండి — కేవలం ఊహతో కాదు.",
      hi: "रीस्टॉक और ऑफ़र नंबर से तय करें — सिर्फ़ अंदाज़े से नहीं.",
    },
  },
  {
    id: "shop-profile",
    zone: "connect",
    image: "/images/demo/features/business_details_card.webp",
    title: {
      en: "List your shop with a complete profile",
      te: "పూర్తి ప్రొఫైల్‌తో షాప్ లిస్ట్ చేయండి",
      hi: "पूरे प्रोफ़ाइल के साथ दुकान लिस्ट करें",
    },
    problem: {
      en: "Google pin exists but no products, photos, UPI or hours in one place for locals.",
      te: "Google పిన్ ఉంది కానీ ప్రొడక్ట్‌లు, ఫోటోలు, UPI, టైమింగ్స్ ఒకే చోట లేవు.",
      hi: "Google पिन है, पर प्रोडक्ट, फ़ोटो, UPI, टाइमिंग एक जगह नहीं.",
    },
    solution: {
      en: "Business details, photos, publish settings, payment/UPI and products for Citizen.",
      te: "బిజినెస్ డీటెయిల్స్, ఫోటోలు, పబ్లిష్ సెట్టింగ్స్, UPI, ప్రొడక్ట్‌లు — Citizenకు.",
      hi: "बिज़नेस डिटेल, फ़ोटो, पब्लिश सेटिंग, UPI और प्रोडक्ट — Citizen के लिए.",
    },
    advantage: {
      en: "Your digital shop address inside the Loksy town directory.",
      te: "Loksy టౌన్ డైరెక్టరీలో మీ డిజిటల్ షాప్ అడ్రస్.",
      hi: "Loksy टाउन डायरेक्टरी में आपका डिजिटल शॉप अड्रेस.",
    },
  },
  {
    id: "ads",
    zone: "connect",
    image: "/images/demo/features/ad_campaigns.webp",
    title: {
      en: "Ads, pamphlets & display board",
      te: "యాడ్స్, పాంఫ్లెట్లు & డిస్‌ప్లే బోర్డ్",
      hi: "ऐड्स, पैम्फ़लेट और डिस्प्ले बोर्ड",
    },
    problem: {
      en: "Print pamphlets once a year; offers die in WhatsApp status.",
      te: "ఏడాదికి ఒకసారి ప్రింట్ పాంఫ్లెట్; ఆఫర్లు WhatsApp స్టేటస్‌లో చచ్చిపోతాయి.",
      hi: "साल में एक बार प्रिंट पैम्फ़लेट; ऑफ़र WhatsApp स्टेटस में मर जाते हैं.",
    },
    solution: {
      en: "Ad Studio banners, posters, events, pamphlets and in-shop display board.",
      te: "Ad Studio బ్యానర్లు, పోస్టర్లు, ఈవెంట్లు, పాంఫ్లెట్లు, డిస్‌ప్లే బోర్డ్.",
      hi: "Ad Studio बैनर, पोस्टर, इवेंट, पैम्फ़लेट और डिस्प्ले बोर्ड.",
    },
    advantage: {
      en: "Stay visible every day without a designer on payroll.",
      te: "డిజైనర్ లేకుండానే ప్రతిరోజూ కనిపించండి.",
      hi: "डिज़ाइनर के बिना भी रोज़ दिखें.",
    },
  },
  {
    id: "coupons",
    zone: "connect",
    image: "/images/demo/features/deals_coupons_card.webp",
    title: {
      en: "Coupons & loyalty loops",
      te: "కూపన్లు & లాయల్టీ లూప్‌లు",
      hi: "कूपन और लॉयल्टी लूप",
    },
    problem: {
      en: "Discounts shouted verbally — no track of who redeemed what.",
      te: "డిస్కౌంట్ మాటల్లోనే — ఎవరు రిడీమ్ చేశారో ట్రాక్ లేదు.",
      hi: "डिस्काउंट सिर्फ़ ज़ुबानी — किसने क्या रिडीम किया ट्रैक नहीं.",
    },
    solution: {
      en: "Create and publish coupons from Connect; citizens redeem in the app.",
      te: "Connect నుంచి కూపన్లు క్రియేట్/పబ్లిష్; సిటిజన్లు యాప్‌లో రిడీమ్.",
      hi: "Connect से कूपन बनाएँ/पब्लिश करें; सिटिज़न ऐप में रिडीम करें.",
    },
    advantage: {
      en: "Repeat visits with measurable offers — not blind markdowns.",
      te: "కొలవగల ఆఫర్లతో రిపీట్ విజిట్లు — గుడ్డి డిస్కౌంట్ కాదు.",
      hi: "मापने योग्य ऑफ़र से दोबारा विज़िट — अंधा डिस्काउंट नहीं.",
    },
  },
  {
    id: "tokens",
    zone: "connect",
    image: "/images/demo/features/live_kitchen_tokens_card.png",
    title: {
      en: "Token system & customer orders",
      te: "టోకెన్ సిస్టమ్ & కస్టమర్ ఆర్డర్లు",
      hi: "टोकन सिस्टम और कस्टमर ऑर्डर",
    },
    problem: {
      en: "Long queues, token chits lost, kitchen chaos, no order history.",
      te: "పొడవైన క్యూలు, టోకెన్ చీట్లు పోవడం, కిచెన్ గందరగోళం, ఆర్డర్ హిస్టరీ లేదు.",
      hi: "लंबी कतार, टोकन पर्ची खो जाना, किचन अफरा-तफरी, ऑर्डर हिस्ट्री नहीं.",
    },
    solution: {
      en: "Token board, number display, shop orders inbox, convert indent → cart bill.",
      te: "టోకెన్ బోర్డ్, నంబర్ డిస్‌ప్లే, ఆర్డర్స్ ఇన్‌బాక్స్, ఇండెంట్ → కార్ట్ బిల్.",
      hi: "टोकन बोर्ड, नंबर डिस्प्ले, ऑर्डर इनबॉक्स, इंडेंट → कार्ट बिल.",
    },
    advantage: {
      en: "Citizens scan, order and wait without standing in Q — you bill cleanly.",
      te: "సిటిజన్లు స్కాన్ చేసి ఆర్డర్ — క్యూలో నిలబడకుండా; మీరు క్లీన్‌గా బిల్.",
      hi: "सिटिज़न स्कैन कर ऑर्डर करें — कतार में खड़े बिना; आप साफ़ बिल करें.",
    },
  },
  {
    id: "feedback",
    zone: "connect",
    image: "/images/demo/features/customer_feedback_card.png",
    title: {
      en: "Feedback, polls & testimonials",
      te: "ఫీడ్‌బ్యాక్, పోల్స్ & టెస్టిమోనియల్స్",
      hi: "फ़ीडबैक, पोल्स और टेस्टिमोनियल",
    },
    problem: {
      en: "Angry customers leave quietly; happy ones never write a review.",
      te: "కోపంగా ఉన్నవాళ్లు మౌనంగా వెళ్తారు; సంతోషంగా ఉన్నవాళ్లు రివ్యూ రాయరు.",
      hi: "नाराज़ चुपचाप जाते हैं; ख़ुश रिव्यू नहीं लिखते.",
    },
    solution: {
      en: "Customer voices hub, shop polls and testimonials published to Citizen.",
      te: "కస్టమర్ వాయిసెస్ హబ్, షాప్ పోల్స్, టెస్టిమోనియల్స్ — Citizenకు.",
      hi: "कस्टमर वॉइस हब, शॉप पोल्स और टेस्टिमोनियल — Citizen पर.",
    },
    advantage: {
      en: "Social proof + product decisions from real local voices.",
      te: "లోకల్ వాయిస్‌ల నుంచి సోషల్ ప్రూఫ్ + ప్రొడక్ట్ నిర్ణయాలు.",
      hi: "लोकल आवाज़ों से सोशल प्रूफ़ + प्रोडक्ट फ़ैसले.",
    },
  },
  {
    id: "directory",
    zone: "citizen",
    image: "/images/demo/features/citizen-home.png",
    title: {
      en: "Search directory & radius discovery",
      te: "సెర్చ్ డైరెక్టరీ & రేడియస్ డిస్కవరీ",
      hi: "सर्च डायरेक्टरी और रेडियस डिस्कवरी",
    },
    problem: {
      en: "Locals don’t know you opened a new service two streets away.",
      te: "రెండు వీధుల దూరంలో కొత్త సర్వీస్ మొదలుపెట్టినా లోకల్స్‌కు తెలియదు.",
      hi: "दो गलियाँ दूर नई सेवा शुरू की — लोकल को पता नहीं.",
    },
    solution: {
      en: "Categories, My Town, radius expand, voice search and shop pages with Call / WhatsApp / Navigate.",
      te: "కేటగిరీలు, My Town, రేడియస్, వాయిస్ సెర్చ్, కాల్/WhatsApp/నావిగేట్ షాప్ పేజీ.",
      hi: "कैटेगरी, My Town, रेडियस, वॉइस सर्च, कॉल/WhatsApp/नेविगेट शॉप पेज.",
    },
    advantage: {
      en: "Demand finds supply without paid aggregator commissions for every walk-in.",
      te: "ప్రతి వాక్-ఇన్‌కు అగ్రిగేటర్ కమిషన్ లేకుండా డిమాండ్ సప్లయ్‌ను కలుస్తుంది.",
      hi: "हर वॉक-इन पर एग्रीगेटर कमीशन के बिना मांग सप्लाई से मिलती है.",
    },
  },
  {
    id: "scan-order",
    zone: "citizen",
    image: "/images/demo/features/shop_orders_card.png",
    title: {
      en: "Scan, order, token & pay",
      te: "స్కాన్, ఆర్డర్, టోకెన్ & పే",
      hi: "स्कैन, ऑर्डर, टोकन और पे",
    },
    problem: {
      en: "Customers hate queues; staff hate handwritten tokens.",
      te: "కస్టమర్లకు క్యూ అసహ్యం; స్టాఫ్‌కు చేతిరాత టోకెన్లు అసహ్యం.",
      hi: "कस्टमर को कतार नापसंद; स्टाफ़ को हाथ से टोकन नापसंद.",
    },
    solution: {
      en: "Shop QR scan → catalog request → token waiting → payment success on Citizen.",
      te: "షాప్ QR స్కాన్ → కేటలాగ్ రిక్వెస్ట్ → టోకెన్ వెయిటింగ్ → పేమెంట్ సక్సెస్.",
      hi: "शॉप QR स्कैन → कैटलॉग रिक्वेस्ट → टोकन वेटिंग → पेमेंट सक्सेस.",
    },
    advantage: {
      en: "Modern QSR feel for any local outlet — paired with Vyapar token board.",
      te: "ఏ లోకల్ అవుట్‌లెట్‌కైనా QSR ఫీల్ — Vyapar టోకెన్ బోర్డ్‌తో.",
      hi: "किसी भी लोकल आउटलेट को QSR फील — Vyapar टोकन बोर्ड के साथ.",
    },
  },
  {
    id: "citizen-engage",
    zone: "citizen",
    image: "/images/demo/features/announcements_card.webp",
    title: {
      en: "Coupons, spin, watch & local pulse",
      te: "కూపన్లు, స్పిన్, వాచ్ & లోకల్ పల్స్",
      hi: "कूपन, स्पिन, वॉच और लोकल पल्स",
    },
    problem: {
      en: "Town apps feel empty; people open Instagram instead of your shop.",
      te: "టౌన్ యాప్స్ ఖాళీగా అనిపిస్తాయి; మీ షాప్ బదులు Instagram తెరుస్తారు.",
      hi: "टाउन ऐप्स खाली लगते हैं; आपकी दुकान की जगह Instagram खुलता है.",
    },
    solution: {
      en: "Rewards, spin, watch ads, pamphlets, daily updates and job alerts keep citizens opening Loksy.",
      te: "రివార్డ్స్, స్పిన్, వాచ్ యాడ్స్, పాంఫ్లెట్లు, డైలీ అప్‌డేట్స్, జాబ్ అలర్ట్స్ — సిటిజన్లు Loksy తెరుస్తారు.",
      hi: "रिवॉर्ड्स, स्पिन, वॉच ऐड्स, पैम्फ़लेट, डेली अपडेट, जॉब अलर्ट — सिटिज़न Loksy खोलते हैं.",
    },
    advantage: {
      en: "Network effects: more citizen opens → more eyes on your Connect content.",
      te: "నెట్‌వర్క్ ఎఫెక్ట్: ఎక్కువ సిటిజన్ ఓపెన్స్ → మీ Connect కంటెంట్‌కు ఎక్కువ కళ్లు.",
      hi: "नेटवर्क इफ़ेक्ट: ज़्यादा सिटिज़न ओपन → आपके Connect कंटेंट पर ज़्यादा नज़रें.",
    },
  },
];

export const DEMO_OUTLETS = [
  { id: "kirana", label: { en: "Kirana", te: "కిరాణా", hi: "किराना" } },
  { id: "cafe", label: { en: "Cafe", te: "కేఫ్", hi: "कैफ़े" } },
  { id: "qsr", label: { en: "QSR / Food", te: "QSR / ఫుడ్", hi: "QSR / फ़ूड" } },
  { id: "salon", label: { en: "Salon", te: "సెలూన్", hi: "सैलून" } },
  { id: "clinic", label: { en: "Clinic", te: "క్లినిక్", hi: "क्लिनिक" } },
  { id: "bakery", label: { en: "Bakery", te: "బేకరీ", hi: "बेकरी" } },
  { id: "tuition", label: { en: "Tuition", te: "ట్యూషన్", hi: "ट्यूशन" } },
  { id: "services", label: { en: "Local services", te: "లోకల్ సర్వీసులు", hi: "लोकल सेवाएँ" } },
  { id: "street", label: { en: "Street vendor", te: "స్ట్రీట్ వెండర్", hi: "स्ट्रीट वेंडर" } },
  { id: "chain", label: { en: "Multi-outlet", te: "మల్టీ-అవుట్‌లెట్", hi: "मल्टी-आउटलेट" } },
];

export const DEMO_COMPARE = [
  {
    notebook: {
      en: "Bills in diary / WhatsApp",
      te: "డైరీ / WhatsApp బిల్లులు",
      hi: "डायरी / WhatsApp बिल",
    },
    loksy: {
      en: "Catalog POS + drafts + taxes",
      te: "కేటలాగ్ POS + డ్రాఫ్ట్‌లు + టాక్స్",
      hi: "कैटलॉग POS + ड्राफ़्ट + टैक्स",
    },
  },
  {
    notebook: {
      en: "Stock by memory",
      te: "మెమరీతో స్టాక్",
      hi: "याददाश्त से स्टॉक",
    },
    loksy: {
      en: "Inventory + categories",
      te: "ఇన్వెంటరీ + కేటగిరీలు",
      hi: "इन्वेंटरी + कैटेगरी",
    },
  },
  {
    notebook: {
      en: "No digital shop for locals",
      te: "లోకల్స్‌కు డిజిటల్ షాప్ లేదు",
      hi: "लोकल के लिए डिजिटल दुकान नहीं",
    },
    loksy: {
      en: "Connect profile on Citizen",
      te: "Citizenలో Connect ప్రొఫైల్",
      hi: "Citizen पर Connect प्रोफ़ाइल",
    },
  },
  {
    notebook: {
      en: "Queue + paper tokens",
      te: "క్యూ + కాగితం టోకెన్లు",
      hi: "कतार + कागज़ी टोकन",
    },
    loksy: {
      en: "Scan → token → bill",
      te: "స్కాన్ → టోకెన్ → బిల్",
      hi: "स्कैन → टोकन → बिल",
    },
  },
];

export const DEMO_FAQS = [
  {
    q: {
      en: "Is Loksy Vyapar only for restaurants?",
      te: "Loksy Vyapar కేవలం రెస్టారెంట్లకేనా?",
      hi: "क्या Loksy Vyapar सिर्फ़ रेस्तराँ के लिए है?",
    },
    a: {
      en: "No — kirana, salon, clinic, tuition, bakery, street vendors and multi-outlet shops are first-class.",
      te: "కాదు — కిరాణా, సెలూన్, క్లినిక్, ట్యూషన్, బేకరీ, స్ట్రీట్ వెండర్, మల్టీ-అవుట్‌లెట్ అన్నీ సపోర్ట్.",
      hi: "नहीं — किराना, सैलून, क्लिनिक, ट्यूशन, बेकरी, स्ट्रीट वेंडर और मल्टी-आउटलेट सबके लिए.",
    },
  },
  {
    q: {
      en: "Do I need both apps?",
      te: "రెండు యాప్స్ అవసరమా?",
      hi: "क्या दोनों ऐप्स चाहिए?",
    },
    a: {
      en: "Shop owners run Loksy Vyapar. Customers use Loksy Citizen. Connect publishes from Vyapar into Citizen.",
      te: "షాప్ ఓనర్లు Loksy Vyapar. కస్టమర్లు Loksy Citizen. Connect Vyapar నుంచి Citizenకు పబ్లిష్ చేస్తుంది.",
      hi: "दुकानदार Loksy Vyapar चलाएँ. ग्राहक Loksy Citizen. Connect Vyapar से Citizen पर पब्लिश करता है.",
    },
  },
  {
    q: {
      en: "What happens after I book a demo?",
      te: "డెమో బుక్ చేసాక ఏమవుతుంది?",
      hi: "डेमो बुक करने के बाद क्या होता है?",
    },
    a: {
      en: "Your request is saved as a Demo enquiry. Our team calls you; staff see it under Loksy Leads → Demo Requests.",
      te: "మీ రిక్వెస్ట్ Demo ఎంక్వైరీగా సేవ్ అవుతుంది. టీమ్ కాల్ చేస్తుంది; స్టాఫ్ Loksy Leads → Demo Requestsలో చూస్తారు.",
      hi: "आपका अनुरोध Demo enquiry के रूप में सेव होता है. टीम कॉल करती है; स्टाफ़ Loksy Leads → Demo Requests में देखता है.",
    },
  },
  {
    q: {
      en: "Which languages are supported?",
      te: "ఏ భాషలు సపోర్ట్?",
      hi: "कौन-सी भाषाएँ सपोर्ट हैं?",
    },
    a: {
      en: "Apps and this page: English, Telugu and Hindi.",
      te: "యాప్స్ + ఈ పేజీ: ఇంగ్లీష్, తెలుగు, హిందీ.",
      hi: "ऐप्स और यह पेज: अंग्रेज़ी, तेलुगु, हिंदी.",
    },
  },
];

export const DEMO_PURPOSE_OPTIONS = [
  "Loksy Vyapar full demo",
  "Loksy Citizen demo",
  "Both apps demo",
  "Billing / POS demo",
  "Connect with Loksy / ads demo",
  "Token / orders demo",
  "Other enquiry",
];

export function t(copy, lang) {
  return copy[lang] || copy.en;
}
